<template>
  <div class="forget-password-container">
    <h1 class="title">修改密码</h1>
    <!-- 新密码输入框 -->
    <input
      v-model="newPassword"
      type="password"
      placeholder="请输入新密码"
      class="input-field"
    />
    <!-- 确认新密码输入框 -->
    <input
      v-model="confirmPassword"
      type="password"
      placeholder="请再次输入新密码"
      class="input-field"
    />
    <!-- 提交修改密码按钮 -->
    <button @click="submitNewPassword" class="submit-button">提交修改</button>
    <!-- 显示密码强度提示 -->
    <p v-if="!isPasswordStrong" class="password-tip">
      密码需包含字母、数字和特殊字符，且长度至少为 8 位
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newPassword: "", // 新密码
      confirmPassword: "", // 确认新密码
    };
  },
  computed: {
    // 计算密码是否符合强度要求
    isPasswordStrong() {
      const passwordRegex =
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
      return passwordRegex.test(this.newPassword);
    },
  },
  methods: {
    // 提交新密码的方法
    submitNewPassword() {
      if (this.newPassword === this.confirmPassword) {
        if (this.isPasswordStrong) {
          // 这里可以添加提交新密码的逻辑，例如调用 API
          console.log("密码修改成功");
        } else {
          console.log("密码强度不足，请重新输入");
        }
      } else {
        console.log("两次输入的密码不一致");
      }
    },
  },
};
</script>
<style scoped>
.forget-password-container {
  width: 350px;
  margin: 50px auto;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
}

.title {
  text-align: center;
  color: #333333;
  margin-bottom: 20px;
}

.input-field {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
}

.input-field:focus {
  outline: none;
  border-color: #007bff;
}

.submit-button {
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.submit-button:hover {
  background-color: #0056b3;
}

.password-tip {
  color: #dc3545;
  font-size: 14px;
  text-align: center;
  margin-top: 10px;
}
</style>

